import "../stakeholderlayout.css";

export default function Governance() {
  return (
    <div className="pillar-section">
      <div className="pillar-header">
        <span className="emoji">🔷</span>
        <h2>STEP 4: GOVERNANCE & EVOLUTION</h2>
        <span className="subtitle">Sustain Outcomes Through Accountability & Learning</span>
      </div>

      <div className="pillar-content">
        <h3>Purpose</h3>
        <p>
          To ensure that institutional changes endure through governance mechanisms, ethical
          oversight, review cycles, and adaptive learning.
        </p>

        <h3>Why This Step Matters</h3>
        <p>
          Many initiatives fail after initial success due to lack of governance, accountability, and
          learning loops.
        </p>

        <h3>Governance Mechanisms</h3>
        <ul>
          <li>Review cadence</li>
          <li>Ethics and compliance controls</li>
          <li>Performance evaluation</li>
          <li>Learning loops and feedback systems</li>
          <li>Continuous improvement pipelines</li>
        </ul>

        <h3>Evolution Principles</h3>
        <ul>
          <li>Institutional memory</li>
          <li>Evidence-based adaptation</li>
          <li>Ethical oversight</li>
          <li>Long-term sustainability</li>
        </ul>

        <h3>Outputs</h3>
        <ul>
          <li>Governance charter</li>
          <li>Review system</li>
          <li>Improvement pipeline</li>
          <li>Institutional learning framework</li>
        </ul>

        <div className="cta">
          <a href="/approach/governance-evolution" className="learn-more">
            Click → Deep Page
            <span className="arrow">👉</span>
          </a>
        </div>
      </div>
    </div>
  );
}